import React from 'react';
import { Box, Button, Typography, Modal } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface LockCardSuccessModalProps {
  onClose: () => void;
  action?: 'lock' | 'unlock';
}

function LockCardSuccessModal({ onClose, action = 'lock' }: LockCardSuccessModalProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <Modal
      open={true}
      onClose={onClose}
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: 'blur(5px)',
            bgcolor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          pt: '35vh',
          height: '100vh',
          width: '100vw',
        }}
      >
        <Box
          sx={{
            bgcolor: 'background.paper',
            borderRadius: 2,
            p: 3,
            width: '85%',
            maxWidth: 400,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Typography
            variant="h2"
            sx={{
              textAlign: 'center',
              fontWeight: 700,
              color: 'text.primary',
              p: 1,
            }}
          >
            {t(action === 'lock' ? 'mobileCardModalsLockSuccessTitle' : 'mobileCardModalsUnlockSuccessTitle')}
          </Typography>
          <Typography
            variant="large"
            sx={{
              textAlign: 'center',
              color: 'text.primary',
              fontWeight: 300,
              lineHeight: 1.5,
              p: 1,
            }}
          >
            {t(
              action === 'lock'
                ? 'mobileCardModalsLockSuccessDescription'
                : 'mobileCardModalsUnlockSuccessDescription'
            )}
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1.5 }}>
            <Button
              fullWidth
              variant="contained"
              onClick={onClose}
              sx={{
                py: 2.5,
                borderRadius: 2,
                textTransform: 'none',
                fontSize: '1.5rem',
                bgcolor: 'primary.main',
                '&:hover': {
                  bgcolor: 'primary.dark',
                },
              }}
            >
              {t('mobileCardModalsBack')}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

export default LockCardSuccessModal;
